import Fetch from "./Fetch";

import { API_BASIC_URL_RULE_ENGINE, API_BASIC_URL_SLOT_SERVICE } from "../config/constants";
import { handleError, handleResponse } from "./ApiUtils";

export const fetchShipmentTypeList = () => {
  return Fetch.get(`${API_BASIC_URL_RULE_ENGINE}/api/v1/shipment-type`).then(handleResponse).catch(handleError);
};

export const fetchPosZoneServiceTypeList = (data) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/delivery-bag/pos-zone-service-mapping`, data).then(handleResponse).catch(handleError);
};

export const fetchDlvFeeCurrentConfigurationList = (data) => {
  return Fetch.get(`${API_BASIC_URL_RULE_ENGINE}/api/v1/delivery-fee-config/country/${data.countryName}`, data.payload).then(handleResponse).catch(handleError);
};

export const fetchDlvFeeConfigurationBasedOnPosAndZone = (data) => {
  return Fetch.get(`${API_BASIC_URL_RULE_ENGINE}/api/v1/delivery-fee-config/${data.posNo}/${data.zone}`).then(handleResponse).catch(handleError);
};

export const createOrUpdateMultiShipmentDeliveryFeeconfig = (data) => {
  return Fetch.create(`${API_BASIC_URL_RULE_ENGINE}/api/v1/delivery-fee-config/multi-shipment/country/${data.countryName}`, data.payload_Object).then(handleResponse).catch(handleError);
};

export const fetchDlvFeeCurrentConfigurationListWithSearch = (data) => {
  return Fetch.get(`${API_BASIC_URL_RULE_ENGINE}/api/v1/delivery-fee-config/${data.countryName}`, data.payload).then(handleResponse).catch(handleError);
};

export const postCreateNewDeliveryFeeconfig = (data) => {
  return Fetch.create(`${API_BASIC_URL_RULE_ENGINE}/api/v2/delivery-fee/config/country/${data.name}`, data.payload_Object).then(handleResponse).catch(handleError);
};

export const postUpdateDeliveryFeeconfig = (data) => {
  return Fetch.update(`${API_BASIC_URL_RULE_ENGINE}/api/v2/delivery-fee/config`, data.payload_Object).then(handleResponse).catch(handleError);
};
